var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIconChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.283,
    height: 16.469,
    viewBox: "0 0 17.283 16.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-373.23 -432.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_111",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 111",
    transform: "translate(381.041 439.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_33",
    "data-name": "\\u30D1\\u30B9 33",
    d: "M395.73,457.259v2.33a1,1,0,0,0,1,1h5.981l1.994,1.994V454.6a1,1,0,0,0-1-1h-2.475",
    transform: "translate(-395.73 -453.608)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_34",
    "data-name": "\\u30D1\\u30B9 34",
    d: "M383.05,433.055H374.9a1.165,1.165,0,0,0-1.165,1.165v9.32l2.33-2.33h6.99a1.165,1.165,0,0,0,1.165-1.165V434.22A1.165,1.165,0,0,0,383.05,433.055Z",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_1",
    "data-name": "\\u7DDA 1",
    x2: 4.984,
    transform: "translate(376.388 436.063)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_2",
    "data-name": "\\u7DDA 2",
    x2: 1.661,
    transform: "translate(376.388 438.057)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconChat);
export default __webpack_public_path__ + "static/media/nav-icon-chat.79be4a49f29f959b4b7ac6024087ad7b.svg";
export { ForwardRef as ReactComponent };